import React, { useState, useEffect, useRef } from 'react';
import { db } from '../firebase';
import { useNavigate } from "react-router-dom";

import {
  collection,
  query,
  getDocs,
} from "firebase/firestore";

const EventComponent = () => {

  const [eventData, setEventData] = useState([]); // Rename to coursesData
  const navigate = useNavigate();


  const [hovered, setHovered] = useState(false);
  const containerRef = useRef(null);
  const contentRef = useRef(null);

  const handleEventClick = (eventId) => {
    navigate(`/events/${eventId}`);
  };
  useEffect(() => {
    const fetchData = async () => {
      const q = query(
        collection(db, "Event")
      );
      const querySnapshot = await getDocs(q);

      const event = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setEventData(event);

      console.log(event);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const container = containerRef.current;
    const content = contentRef.current;

    if (!container || !content || eventData.length === 0) {
      return undefined;
    }

    let animationFrameId;
    let initialTimestamp;

    const updateScrollPosition = (timestamp) => {
      if (!initialTimestamp) {
        initialTimestamp = timestamp;
      }

      const progress = timestamp - initialTimestamp;
      const maxScroll = content.scrollWidth - container.offsetWidth;
      const newXPosition = Math.min(progress / 40, maxScroll);

      content.style.transform = `translateX(-${newXPosition}px)`;

      if (!hovered && newXPosition >= maxScroll - 280) {
        content.style.transform = 'translateX(0)';
        initialTimestamp = null;
      }

      if (!hovered && newXPosition < maxScroll) {
        animationFrameId = requestAnimationFrame(updateScrollPosition);
      }
    };

    if (!hovered) {
      animationFrameId = requestAnimationFrame(updateScrollPosition);
    }

    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, [hovered, eventData]);

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  return eventData.length ? (
    <div className='event-component-container-parent'>
      <h2>Events</h2>

      <div
        className="event-component-container"
        style={{ width: '100%', height: '300px' }}
        ref={containerRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="event-component-content" ref={contentRef}>
          {eventData.map((event) => (
            <div onClick={() => handleEventClick(event.id)} style={{ cursor: 'pointer' }} className="event-item">
              <img className='event-item' style={{
                maxWidth: '200px'
              }} src={event?.images?.[0]} alt='' />
            </div>
          ))}
        </div>
      </div>
    </div>
  ) : '';
};

export default EventComponent;
